var render = function render(){var _vm=this,_c=_vm._self._c;return _c('video-player',{ref:"video-player",attrs:{"options":_vm.videoOptions,"video":_vm.data},on:{"start-video":_vm.startVideo,"init-video":_vm.initVideo,"end-video":_vm.endVideo,"current-time-video":_vm.currentTimeVideo}})
}
var staticRenderFns = []

export { render, staticRenderFns }